import React from "react";
import logo from "./logo.svg";
import "./App.scss";
import ComparisonCharts from "./containers/comparison-charts";
import TotalStats from "./components/total-stats";
import StateDistrictTable from "./components/StateDistrictTable/StateDistrictTable";

function App() {
  return (
    <div className="main-app">
      {/* <StatesTagCloud/> */}
      {/* Comparison Charts */}
      <TotalStats />
      <StateDistrictTable />
      <ComparisonCharts />
      {/* Table */}
      {/* Gender pie chart */}
    </div>
  );
}

export default App;
